import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import '../../css/Dialog.css';

const fmtDate = (val) => {
  if (!val) return '—';
  const d = new Date(val);
  if (isNaN(d)) return val;
  return d.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: '2-digit' });
};

const RequestCancellationDialog = ({
  open,
  leave,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleConfirm = () => {
    onSubmit(reason.trim());
    setReason('');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{ paper: { className: 'modern-dialog' } }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle className="modern-dialog-title">
        <span className="modern-dialog-title-text">
          Request Leave Cancellation
        </span>
        <IconButton aria-label="close" onClick={handleClose} className="modern-dialog-close-btn">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="modern-dialog-content">
        {leave && (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Are you sure you want to request cancellation for this approved leave?
            </Typography>

            {/* Date · Reason summary */}
            <Typography
              variant="caption"
              color="text.disabled"
              sx={{ display: 'block', mb: 1.5, fontWeight: 600 }}
            >
              {fmtDate(leave.startDate)} – {fmtDate(leave.endDate)}
              {leave.reason ? `  ·  ${leave.reason}` : ''}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            {/* Cancellation reason textarea */}
            <TextField
              id="cancellation-reason-input"
              label="Reason for Cancellation"
              multiline
              rows={3}
              fullWidth
              size="small"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why do you want to cancel this leave?"
            />
          </>
        )}
      </DialogContent>

      <DialogActions className="modern-dialog-actions">
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          disabled={loading}
          sx={{ borderColor: '#e2e8f0', color: '#64748b' }}
        >
          Close
        </Button>
        <Button
          id="submit-leave-cancellation-btn"
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={loading}
          disableElevation
          startIcon={<EventBusyIcon fontSize="small" />}
        >
          {loading ? 'Submitting…' : 'Submit Request'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestCancellationDialog;
